/* ============================================================
   Sola — entrada em cascata, aplicada de fora.

   Percorre as secoes e marca candidatos (titulo, paragrafo de apoio,
   cards repetidos) para revelar no scroll. Nao altera markup de origem,
   nao toca em carrossel, nao mexe em nada que ja tenha animacao propria.

   Para desligar numa secao: data-sola-motion="off" no elemento da secao.
   ============================================================ */
(function () {
  if (window.__solaMotion) return;
  window.__solaMotion = true;

  var REDUZIR = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUZIR || !('IntersectionObserver' in window)) return;

  // Regioes onde mexer custa mais do que rende.
  var PROIBIDO = [
    '.swiper', '.slider', 'slider-component', 'media-gallery',
    '.product__media-wrapper', '.product__info-wrapper',
    '.header', '.tp-footer', '.announcement-bar-section',
    '[data-sola-steps]', '.sola-reveal', '.tp-reveal',
    '.qb-v2__flavors', '.quantity-bundle--v2'
  ].join(',');

  var CANDIDATOS = [
    '.tp-title', '.tp-section-title', '.tp-heading',
    '.tp-subtitle', '.tp-description',
    '.tp-card-wrapper', '.tp-benefit-card', '.tp-feature',
    '.tp-image-with-text__content', '.tp-image-with-text__media'
  ].join(',');

  function dentroDeProibido(el, secao) {
    var p = el.parentElement;
    while (p && p !== secao) {
      if (p.matches && p.matches(PROIBIDO)) return true;
      p = p.parentElement;
    }
    return false;
  }

  function preparar(secao) {
    if (secao.dataset.solaMotion === 'off' || secao.dataset.solaMotionBound === '1') return;
    secao.dataset.solaMotionBound = '1';

    var alvos = Array.prototype.slice.call(secao.querySelectorAll(CANDIDATOS))
      .filter(function (el) {
        if (el.classList.contains('sola-reveal') || el.classList.contains('tp-reveal')) return false;
        if (el.closest && el.closest(PROIBIDO) && dentroDeProibido(el, secao)) return false;
        return true;
      })
      .slice(0, 12);

    if (!alvos.length) return;

    alvos.forEach(function (el, i) {
      el.classList.add('sola-anim');
      el.style.setProperty('--sola-i', i);
    });

    // A classe de transicao entra depois do estado inicial pintar,
    // senao o primeiro quadro ja aparece no lugar final.
    requestAnimationFrame(function () {
      alvos.forEach(function (el) { el.classList.add('sola-anim--ready'); });
    });

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        alvos.forEach(function (el) { el.classList.add('sola-anim--in'); });
        io.disconnect();
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    io.observe(secao);
  }

  function varrer() {
    document.querySelectorAll('.shopify-section').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else {
    varrer();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) preparar(e.target);
  });
})();
